/** Default form state when GET returns `businessInformation === null`. */
export const EMPTY_BUSINESS_INFORMATION = Object.freeze({
  instructionForModel: '',
  sections: [],
  referenceLinks: [],
});

/**
 * @param {unknown} url
 * @returns {boolean}
 */
export function isHttpOrHttpsUrl(url) {
  if (typeof url !== 'string') return false;
  const t = url.trim();
  return t.startsWith('http://') || t.startsWith('https://');
}

/**
 * Normalize API payload into editable form state (non-null object).
 * @param {Record<string, unknown> | null | undefined} raw
 * @returns {{ instructionForModel: string; sections: { heading: string; body: string }[]; referenceLinks: { label: string; url: string; notes: string }[] }}
 */
export function normalizeAgentBusinessInformation(raw) {
  if (raw == null || typeof raw !== 'object') {
    return {
      instructionForModel: '',
      sections: [],
      referenceLinks: [],
    };
  }
  const instructionForModel =
    typeof raw.instructionForModel === 'string' ? raw.instructionForModel : '';
  const sections = Array.isArray(raw.sections)
    ? raw.sections.map((s) => ({
        heading: typeof s?.heading === 'string' ? s.heading : '',
        body: typeof s?.body === 'string' ? s.body : '',
      }))
    : [];
  const referenceLinks = Array.isArray(raw.referenceLinks)
    ? raw.referenceLinks.map((r) => ({
        label: typeof r?.label === 'string' ? r.label : '',
        url: typeof r?.url === 'string' ? r.url : '',
        notes: typeof r?.notes === 'string' ? r.notes : '',
      }))
    : [];
  return { instructionForModel, sections, referenceLinks };
}

/**
 * @param {{ instructionForModel: string; sections: unknown[]; referenceLinks: { url?: string }[] }} bi
 * @returns {{ ok: true } | { ok: false; message: string }}
 */
export function validateBusinessInformationForSave(bi) {
  if (!bi || typeof bi !== 'object') return { ok: false, message: 'Business information is invalid.' };
  if (!Array.isArray(bi.sections) || !Array.isArray(bi.referenceLinks)) {
    return { ok: false, message: 'Sections and reference links must be arrays.' };
  }
  for (let i = 0; i < bi.referenceLinks.length; i += 1) {
    const url = bi.referenceLinks[i]?.url;
    if (!isHttpOrHttpsUrl(url)) {
      return {
        ok: false,
        message: `Reference link ${i + 1}: URL must start with http:// or https://.`,
      };
    }
  }
  return { ok: true };
}
